import moment from "moment";

export default {
  filters: {
    // Date and time filters
    shortDate(date) {
      return moment(date).format("DD.MM.YY");
    },
    shortDateTime(date) {
      return moment(date).format("DD.MM.YY HH:mm");
    },
    fullDateTime(date) {
      return moment(date).format('Do MMM YYYY, HH:mm');
    },
    longDate(date) {
      return moment(date).format("Do MMMM YYYY");
    },
    formatDate(date) {
      if (date == "0001-01-01T00:00:00") {
        return ''
      }
      return moment(date).format("DD.MM.YY")
    },
    suffix(value) {
      if (value == 1) {
        return value + " day ago";
      }
      return value + " days ago";
    },
    daySuffix(day) {
      var dayComponents = day.toString().split('')
      if ((dayComponents.length == 2 && dayComponents[0] != '1') || dayComponents.length == 1) {
        var lastDigit = dayComponents.pop()
        if (lastDigit == 1 && day != 11) {
          return `${day}st`
        }
        if (lastDigit == 2 && day != 12) {
          return `${day}nd`
        }
        if (lastDigit == 3 && day != 13) {
          return `${day}rd`
        }
      }
      return `${day}th`
    },
    toTime(period) {
      if (period > 48) return "Invalid period";
      let hours = (period - 1) / 2;
      let time = "";
      if (hours % 1 === 0) {
        time = hours + ":" + "00";
      } else {
        let hour = hours.toString().split(".");
        time = hour[0] + ":" + "30";
      }
      if (time.length === 4) {
        return "0" + time;
      } else {
        return time;
      }
    },
    timefromNow(time){
      return moment(time).fromNow();
    },
    fromNow(time) {
      return moment().to(time, true);
    },
    showAsTwoDigits(dayOfMonth) {
      dayOfMonth = dayOfMonth.toString();
      if (dayOfMonth.length < 2) {
        dayOfMonth = "0" + dayOfMonth;
      }
      return dayOfMonth;
    },
    // Money filters
    currency(value) {
      if (value) {
        return value.toLocaleString('en-GB', {
          style: 'currency',
          currency: 'GBP'
        });
      } else if (value == 0) {
        return '£0.00'
      }
    },
    splitString(string) {
      if (string == null) return string;
      let splitString = string.match(/[A-Z][a-z]+/g);
      let newString = "";
      splitString.forEach(item => {
        newString += item + " ";
      });
      return newString.trim();
    },
  }
}